import React from "react";
import PropTypes from "prop-types";
import { get } from "lodash";
import { push } from "react-router-redux";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import classNames from "classnames";
import { INVENTORIES } from "MODULES/inventories/constants";
import { dollars } from "LIB/formatters/currency";
import {
  DataTable,
  SearchPropTypes,
  PartNumber,
  LocationFlag
} from "MODULES/shared/components";
import InventoryStatusCell from "MODULES/shared/components/InventoryStatusCell";
import { monthYear, shortDateYY } from "LIB/formatters/date";
import { getFirstNameLastInitial, truncate } from "LIB/formatters/text";

function renderInventoryRow(inventory, i, pushHistory, renderDummyValues) {
  return (
    <tr
      key={renderDummyValues ? `d-${i}` : i}
      className={classNames("clickable", { "text-muted": renderDummyValues })}
      onClick={() => pushHistory(`/inventories/${inventory.uuid}/all`)}
    >
      <td>{i + 1}</td>
      <InventoryStatusCell inventory={inventory}>
        <td>{!renderDummyValues && shortDateYY(inventory.date_received)}</td>
      </InventoryStatusCell>
      {!renderDummyValues && <PartNumber part={inventory.part} />}
      <td>{!renderDummyValues && inventory.serial_number}</td>
      <td>
        {!renderDummyValues && truncate(inventory.exchange_serial_number, 14)}
      </td>
      <td>{!renderDummyValues && truncate(inventory.part.description, 15)}</td>
      <td>
        {!renderDummyValues &&
          inventory.buyer &&
          truncate(getFirstNameLastInitial(inventory.buyer.full_name), 8)}
      </td>
      <td>
        {!renderDummyValues &&
          inventory.co_buyer &&
          truncate(getFirstNameLastInitial(inventory.co_buyer.full_name), 8)}
      </td>
      <td>
        {!renderDummyValues &&
          inventory.third_buyer &&
          getFirstNameLastInitial(inventory.third_buyer.full_name)}
      </td>
      <td className="text-center">
        {!renderDummyValues && (
          <LocationFlag
            location={inventory.store_owner_id}
            consignment_type={inventory.consignment_type}
            inventory={inventory}
          />
        )}
      </td>
      <td className="text-center">
        {!renderDummyValues && (
          <LocationFlag location={inventory.store_location_id} />
        )}
      </td>
      <td>
        {!renderDummyValues &&
          (inventory.location === "At Shop" &&
          inventory.most_recent_repair_order ? (
            <Link
              onClick={e => e.stopPropagation()}
              to={`/repair-orders/${inventory.most_recent_repair_order
                ? inventory.most_recent_repair_order.uuid
                : ""}`}
            >
              {truncate(
                `${inventory.most_recent_repair_order.company.name}`,
                25
              )}
            </Link>
          ) : (
            truncate(inventory.location, 12)
          ))}
      </td>
      <td>
        {renderDummyValues
          ? get(INVENTORIES, `condition.${inventory.dummy.condition}.abbrev`)
          : get(INVENTORIES, `condition.${inventory.condition}.abbrev`)}
      </td>
      <td>{truncate(inventory.tagged_by, 16)}</td>
      <td>{monthYear(inventory.tag_date)}</td>
      <td>{truncate(inventory.traced_to, 15)}</td>
      <td className="text-right">
        {!renderDummyValues &&
          inventory.reserve_for_seller_id && (
            <i className="fa fa-fw fa-lock text-muted" />
          )}{" "}
        {renderDummyValues && (
          <i className="fa fa-fw fa-copy text-muted" />
        )}{" "}
        {renderDummyValues
          ? inventory.dummy.quantity
          : inventory.total_quantity}
      </td>
      <td className="text-right">
        {!renderDummyValues &&
          inventory.cost_per_unit &&
          dollars(inventory.cost_per_unit, 0)}
      </td>
      <td className="text-right">
        {!renderDummyValues &&
          inventory.suggested_retail &&
          dollars(inventory.suggested_retail, 0)}
      </td>
      <td className="text-right">
        {!renderDummyValues &&
          inventory.exchange_srp &&
          dollars(inventory.exchange_srp, 0)}
      </td>
    </tr>
  );
}

function renderRow(inventory, i, pushHistory) {
  if (inventory.dummy) {
    return [
      renderInventoryRow(inventory, i, pushHistory),
      renderInventoryRow(inventory, i, pushHistory, true)
    ];
  }
  return renderInventoryRow(inventory, i, pushHistory);
}

export function Table({ pushHistory, isLoading, results }) {
  return (
    <DataTable loading={isLoading} numbered>
      <DataTable.Head>
        <th />
        <th>Date Rec.</th>
        <th>Part #</th>
        <th>Serial #</th>
        <th>Exchd Serial #</th>
        <th>Description</th>
        <th>Buyer</th>
        <th>Buyer 2</th>
        <th>Buyer 3</th>
        <th className="text-center">Store Owner</th>
        <th className="text-center">Store Loc</th>
        <th>Inv Loc</th>
        <th>CD</th>
        <th>Tagged By</th>
        <th>Tag Date</th>
        <th>Traced To</th>
        <th className="text-right">QTY</th>
        <th className="text-right">Cost/Unit</th>
        <th className="text-right">SRP</th>
        <th className="text-right">Exch SRP</th>
      </DataTable.Head>
      <DataTable.Body>
        {results.map((r, i) => renderRow(r, i, pushHistory))}
      </DataTable.Body>
    </DataTable>
  );
}

Table.propTypes = {
  pushHistory: PropTypes.func.isRequired,
  ...SearchPropTypes
};

export default connect(undefined, { pushHistory: push })(Table);



// WEBPACK FOOTER //
// ./app/modules/inventories/components/Search/Table.jsx